import React, { useRef } from "react";

import { GridSinglePage } from "2g-grid";

import useZadostiOdbaveniGrid from "./hooks/useZadostiOdbaveniGrid";
import ZadostiOdbaveniToolbar from "./ZadostiOdbaveniToolbar";

function ZadostiOdbaveniGrid() {
  const gridRef = useRef();
  const { grid, toolbar } = useZadostiOdbaveniGrid();
  return (
    <>
      <div ref={gridRef}>
        <GridSinglePage {...grid} />
      </div>
      <ZadostiOdbaveniToolbar {...toolbar} gridRef={gridRef} />
    </>
  );
}

export default React.memo(ZadostiOdbaveniGrid);
